import { useEffect, useState } from 'react';
import { useGetPresentacionQuery } from '../../../../services/presentacionesApi';

export const useViewExecutionVisitPresentacion = (idPresentacion: number | null) => {
    const [id, setId] = useState<number | null>(idPresentacion);

    const { data, isFetching } = useGetPresentacionQuery(id!, {
        skip: !id
    });

    useEffect(() => {
        if (idPresentacion) {
            setId(idPresentacion);
        }
    }, [idPresentacion]);

    return {
        presentacion: data,
        loadingPresentacion: isFetching
    };
};
